import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=5c59dca1&"
import script from "./EmailVerification.vue?vue&type=script&lang=js&"
export * from "./EmailVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=5c59dca1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports